import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

export interface JobLiveDetailsPayload {
  assessment_id: string;
  title: string;
  about_role: string;
  responsibilities: string[];
  qualifications: string[];
}

/**
 * Hook to update the live job details (the "Your Job is Live!" card) using React Query mutation.
 *
 * A section the recruiter deleted in the modal comes through as an empty string/array, which is
 * how the endpoint records the removal.
 */
export const useJobLiveDetailsUpdate = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: JobLiveDetailsPayload) => {
      const response = await apiClient.patch(
        '/assessment/job-live-details/',
        payload
      );
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Success',
        text: 'Job details updated successfully',
        type: 'success',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to update job details';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};
